var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Icon } from '../../atoms/Icon';
import { Tooltip } from '../Tooltip';
export var IconText = function (_a) {
    var design = _a.design, props = __rest(_a, ["design"]);
    var _b = useDesign(design), schema = _b.schema, components = _b.components, _c = _b.config, interpolateValues = _c.values, icon = _c.icon, header = _c.header, text = _c.text, tooltip = _c.tooltip;
    var hasIcon = icon || components.icon;
    var hasHeader = header || components.header;
    var hasText = text || components.text;
    var hasTooltip = tooltip || components.tooltip;
    var textProps = __assign(__assign({}, text), props === null || props === void 0 ? void 0 : props.text);
    var tooltipProps = __assign(__assign(__assign(__assign({}, tooltip), ((props === null || props === void 0 ? void 0 : props.popover) || { popover: props === null || props === void 0 ? void 0 : props.popover })), ((props === null || props === void 0 ? void 0 : props.activator) || { activator: props === null || props === void 0 ? void 0 : props.activator })), ((props === null || props === void 0 ? void 0 : props.tooltip) || { popover: props === null || props === void 0 ? void 0 : props.tooltip }));
    var values = __assign(__assign({}, interpolateValues), props === null || props === void 0 ? void 0 : props.values);
    var isLoading = values.isLoading, skeleton = values.skeleton;
    return (_jsxs(GenericComponent, __assign({ schema: schema }, { children: [hasIcon && _jsx(Icon, __assign({ design: components.icon }, icon)), hasHeader && (_jsx(FactoryComponent, __assign({ component: "TranslatedText", design: components.header, id: "".concat(design, ".header") }, header, { isLoading: isLoading, skeleton: skeleton, values: values }))), hasText && (_jsx(FactoryComponent, __assign({ component: "TranslatedText", design: components.text, "aria-labelledby": components.header && "".concat(design, ".header") }, textProps, { isLoading: isLoading, skeleton: skeleton, values: values }))), hasTooltip && (_jsx(Tooltip, __assign({ disabled: false, design: components.tooltip }, tooltipProps, { config: tooltip })))] })));
};
IconText.displayName = 'IconText';
export * from './IconText.types';
